import api from "../../components/api"

export type ResolvedTaxRateLocation = {
  city: string | null
  state: string | null
  zip: string | null
}

export type ResolvedTaxRate = {
  isResolved: boolean
  rate: number
  jurisdiction: string | null
  resolvedLocation: ResolvedTaxRateLocation | null
  submittedLocation: ResolvedTaxRateLocation | null
}

export const getResolvedTaxRate = async (jobId: number): Promise<ResolvedTaxRate> => {
  return (await api.get(`/web/invoicing/jobs/${jobId}/resolved-tax-rate`)).data
}
